export const domain = window.inithealth.config.mainDomain;
export const cdnUrl = window.inithealth.config.cdnUrl;
export const apiDomain = domain + '/api';
export const blogUrl = domain + '/blog/post/';
export const inutraliaURL = domain + '/diet/recipe/';
export const defaultChallenge = 10000;
export const currentLang = window.inithealth.config.lang ? window.inithealth.config.lang.split('_')[0] : 'es';
export const supportedLocales = window.inithealth.config.supportedLocales;
export const showScoreCard = eval(window.inithealth.config.showScoreCard || true);



// WEBPACK FOOTER //
// ./src/config.js